import { actions } from './actions'

const initialState = {
  loading: false,
  success: false,
  convertSuccess: false
}

export const reducerGenerateQR = (state = initialState, action) => {
  switch (action.type) {
    case actions.set_state:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
